import { Field, WrappedFieldProps } from 'redux-form';
import { NumberInput, NumberInputProps } from '@mews-commander/ui';
import { getError } from '../../utils';

const NumberInputRenderer = ({ input, meta, ...other }: NumberInputProps & WrappedFieldProps) => (
    <NumberInput {...meta} {...input} {...other} error={getError(meta)} />
);

export const RateGroupNumberInputField = (props: NumberInputProps) => (
    <Field name={props.name} props={props} component={NumberInputRenderer} />
);
